import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { defaultPostBakingWasteWoodCountWoodSizeAmountMapDetail } from "../../constance/dataTypes";
import CountWasteWoodForm from "./CountWasteWoodForm";
import ErrorMessage from "../common/ErrorMessage";
import { GET, POST, PUT } from "../../utils/HttpClient";
import { URL_POST_BAKING } from "../../constance/urls";
import * as _ from "lodash";
import Title from "antd/es/typography/Title";
import { Spin, Form, Button, Space } from "antd";
import dayjs from "dayjs";
import { SaveFilled } from "@ant-design/icons";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import useCountWasteWoodValidate from "./useCountWasteWoodValidate";


export default function CountWoodAmount(props) {
  const {
    target,
    groupDate,
    ovens,
    getTransaction,
    onBack,
  } = props;

  const { t } = useTranslation();
  const countWasteWoodValdiate = useCountWasteWoodValidate()
  const isCreate = !target ? true : false;
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null)

  const fetchData = async () => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const response = await GET(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT_WOOD_SIZE_AMOUNT_MAP}${target}/`)
      form.setFieldsValue(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (values) => {
    setLoading(true);
    setErrorMessages(null);

    try {
      const validate = await form.validateFields();
      // validate
        const message = await countWasteWoodValdiate.doValidate({
        date: groupDate, ovens: ovens.join(','),
        grade: values.grade, wood_code_dimension: values.wood_code_dimension,
        amount: values.amount, exclude_target: isCreate ? null : target,
      })

      if (isCreate) {
        await POST(URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT_WOOD_SIZE_AMOUNT_MAP, { ...values, transaction: await getTransaction() })
      } else {
        await PUT(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT_WOOD_SIZE_AMOUNT_MAP}${target}/`, values)
      }
      setErrorMessages(message)
      onBack(message);
    } catch (error) {
      setErrorMessages(_.get(error, 'errorMessages', error))
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (target) {
      fetchData();
    } else {
      form.resetFields();
    }
  }, [target])

  return (
    <div style={{ marginTop: '1rem' }}>
      <Title level={5}>
        {t('post_baking_waste_wood_count.group_date')} {dayjs(groupDate, DATE_FORMAT).format(HUMAN_DATE_FORMAT)}&emsp;
        {ovens.length != 0 ?
          (<div>{t('post_baking_waste_wood_count.oven_no')}: {ovens.join(', ')}</div>) :
          (<div>{t('post_baking_waste_wood_count.all_oven')}</div>)
        }
      </Title>
      <Spin spinning={loading} tip={t('loading')} fullscreen />
      <ErrorMessage message={errorMessages} length={50}/>
      <Form form={form} initialValues={defaultPostBakingWasteWoodCountWoodSizeAmountMapDetail}>
        <CountWasteWoodForm form={form} />
        <Space>
          <Button
            type="primary"
            icon={<SaveFilled />}
            loading={loading}
            onClick={() => handleSubmit(form.getFieldsValue())}
          >{t('save')}</Button>
          <Button
            variant="filled"
            color="default"
            loading={loading}
            onClick={() => onBack()}>
            {t('back')}
            </Button>
        </Space>
      </Form>
      <div style={{ position: "fixed", bottom: "1rem", left: "1rem" }}>
        v.1.22.1(fixed)
      </div>
    </div>
  )
}

CountWoodAmount.propTypes = {
  groupDate: PropTypes.string,
  ovens: PropTypes.array,
  getTransactionId: PropTypes.func,
  onBack: PropTypes.func,
}

CountWoodAmount.defaultProps = {
  groupDate: null,
  ovens: [],
  getTransactionId: () => null,
  onBack: () => null,
}